import {
  Button,
  ButtonProps,
  HStack,
  Icon,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { ImportMethodOption } from "../helpers/getImportMethodsAvailable";
import { ImportMethod } from "../panels/ImportMethodSelectionPanel";

export function CreateEmptyDataSourceButton({
  option,
  onSelect,
  buttonRef,
  onKeyDown,
  buttonProps,
}: {
  option: ImportMethodOption;
  onSelect: (importType: ImportMethod) => void;
  buttonRef?: React.Ref<HTMLButtonElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLButtonElement>;
  buttonProps?: ButtonProps;
}): React.ReactElement {
  return (
    <Button
      ref={buttonRef}
      variant="ghost"
      colorScheme={option.colorScheme}
      h="auto"
      justifyContent="flex-start"
      whiteSpace="normal"
      textAlign="left"
      px={2}
      py={2}
      onClick={() => onSelect(option.importType)}
      onKeyDown={onKeyDown}
      {...buttonProps}
    >
      <HStack align="center" spacing={2}>
        <Icon as={option.icon} boxSize={4} />
        <VStack align="flex-start" spacing={0}>
          <Text fontWeight="bold">{option.label}</Text>
        </VStack>
      </HStack>
    </Button>
  );
}
